import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const SettingsContext = createContext({ settings: {}, loaded: false, refresh: () => {} });

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState({});
    const [loaded, setLoaded] = useState(false);

    const refresh = useCallback(() => {
        return api.get("/settings/public")
            .then((r) => setSettings(r.data || {}))
            .catch(() => {})
            .finally(() => setLoaded(true));
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return (
        <SettingsContext.Provider value={{ settings, loaded, refresh }}>
            {children}
        </SettingsContext.Provider>
    );
}

export function useSettings() {
    return useContext(SettingsContext);
}
